import { ItemListEntry } from '@components/itemListEntry';
import { useFragment } from 'react-relay';
import { itemListFragment } from './ItemList.relay';
import type { ItemListProps } from './types';

export const ItemList: React.FC<ItemListProps> = ({ component }) => {
  const data = useFragment(itemListFragment, component);

  return (
    <div className={`ItemList-entries mt-2.5 w-[410px] max-[1100px]:w-full ${data.smalllabel ? 'ItemList-entries-small-label' : ''}`}>
      {/* biome-ignore lint/suspicious/noArrayIndexKey: no stable id available */}
      {data.entries?.edges?.map((entry, index) => (entry?.node ? <ItemListEntry key={`itemListEntry-${index}`} component={entry.node} /> : null))}
    </div>
  );
};
